{
	"title": "Tjänsten är inte tillgänglig (500)",
	"description": "Försök att uppdatera sidan eller kontrollera din internetanslutning. Om felet kvarstår, rapportera det som en bugg så att vi kan vidta åtgärder.",
	"primaryButtonTitle": "Uppdatera sidan",
	"secondaryButtonTitle": "Kopiera fellogg",
	"errorLogCopiedMessage": "Fellogg kopierad",
	"traceparentLabel": "Traceparent"
}
